/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Ranking_MembersInputs */

const en_us2_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a ranking visible to members only.`)
};

const pt_br2_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com ranking visível só para os membros.`)
};

const es_419_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con ranking visible solo para los miembros.`)
};

const pt_pt2_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com classificação visível só para os membros.`)
};

const fr_fr2_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec un classement visible par les membres uniquement.`)
};

const de_de2_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einer Rangliste, die nur Mitglieder sehen.`)
};

const it_it2_clubs_ranking_members = /** @type {(inputs: Clubs_Ranking_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una classifica visibile solo ai membri.`)
};

/**
* | output |
* | --- |
* | "With a ranking visible to members only." |
*
* @param {Clubs_Ranking_MembersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_ranking_members = /** @type {((inputs?: Clubs_Ranking_MembersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Ranking_MembersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_ranking_members(inputs)
	if (locale === "es-419") return es_419_clubs_ranking_members(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_ranking_members(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_ranking_members(inputs)
	if (locale === "de-DE") return de_de2_clubs_ranking_members(inputs)
	if (locale === "it-IT") return it_it2_clubs_ranking_members(inputs)
	return en_us2_clubs_ranking_members(inputs)
});
export { clubs_ranking_members as "clubs.ranking_members" }